import React from "react";
import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Services } from "@/components/site/Services";
import { ServiceArea } from "@/components/site/ServiceArea";
import { About } from "@/components/site/About";
import { ContactForm } from "@/components/site/ContactForm";
import { Footer } from "@/components/site/Footer";

function HomePage() {
  return (
    <div data-testid="home-page" className="min-h-screen bg-brand-cream text-brand-ink">
      <Header />
      <main>
        <Hero />
        <Services />
        <ServiceArea />
        <About />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="top-right"
          richColors
          toastOptions={{
            classNames: {
              toast: "font-body",
            },
          }}
        />
      </div>
    </LanguageProvider>
  );
}

export default App;
